import React, { ReactElement } from 'react';
import Panel from './panels/Panel';
import styled from '@emotion/styled';
import ToggleButton from './togglebutton/ToggleButton';
import Button from './buttons/Button';
import CancelButton from './buttons/ProfileCancelButton';
import breakpoints from '../theme/material/breakpoints';
import { DashlineSeparator } from 'components/join/styledElements';

const ButtonContainer = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: 12,
});

const ToggleButtonsContainer = styled('div')(() => ({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  paddingBottom: 12,
  gridGap: '15px',
  [breakpoints.between(768, 820)]: {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
}));

interface EditableInterestedInProps {
  allInterests: any;
  onChangeHandler: any;
  findInterest: any;
  title: any;
  className: any;
  handleCancel: any;
  handleSubmit: any;
  [rest: string]: any;
}

const EditableInterestedIn = ({
  allInterests,
  onChangeHandler,
  findInterest,
  title,
  className,
  handleCancel,
  handleSubmit,
  ...rest
}: EditableInterestedInProps): ReactElement => {
  const checkForAtLeast1 = () => {
    let count = 0;

    for (const property in allInterests) {
      allInterests[property] && count++;
    }
    return count >= 1;
  };

  return (
    <Panel
      withHeader
      title={title}
      className={className}
      isProfile
      cancelButton={
        <CancelButton
          dataTestId="editable-textarea-cancel-btn"
          handleCancel={handleCancel}
          customStyle={{ marginRight: 0 }}
          isTextType
        />
      }
      panelStyle="borderless"
      {...rest}
    >
      <ToggleButtonsContainer>
        {
          // need to iterate through the list of interests and decide whether which ones to set active and which one not to
          Object.keys(allInterests).map((item, index) => (
            <ToggleButton
              key={index}
              title={findInterest(item, 'value')}
              customStyle={{ cursor: 'pointer', order: index + 1, margin: 0 }}
              id={item}
              isChecked={allInterests[item]}
              onChangeHandler={onChangeHandler}
            />
          ))
        }
      </ToggleButtonsContainer>
      <DashlineSeparator style={{ margin: '0' }} />
      <ButtonContainer>
        <Button
          customStyle={{
            padding: '8px 20px',
            fontWeight: 600,
            fontSize: 13,
            lineHeight: '16px',
            borderRadius: '4px !important',
          }}
          buttonType="primaryRed"
          onClick={handleSubmit}
          disabled={!checkForAtLeast1()}
        >
          Save
        </Button>
      </ButtonContainer>
    </Panel>
  );
};

export default EditableInterestedIn;
